import React from 'react';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Tooltip } from 'clad';

import styled from 'styled-components';

const StyledEllipsis = styled.span`
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

@observer
class Ellipsis extends React.Component {
    static propTypes = {
        text: PropTypes.string.isRequired,
        tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    };

    static defaultProps = {
        text: '',
        tooltipOptions: {},
        tooltip: true
    };

    @observable
    tooltipText = '';

    componentDidMount() {
        const { el, props } = this;
        if (props.tooltip === false) {
            return;
        }

        if (el && el.offsetWidth < el.scrollWidth) {
            this.tooltipText =
                props.tooltip === true ? props.text : props.tooltip;
        }
    }

    render() {
        const { tooltipText, props } = this;
        const { className, style, text, tooltipOptions } = props;

        return (
            <Tooltip title={tooltipText} {...tooltipOptions}>
                <StyledEllipsis
                    className={`ellipsis ${className || ''}`}
                    style={{ ...style }}
                    ref={el => {
                        this.el = el;
                    }}
                >
                    {text}
                </StyledEllipsis>
            </Tooltip>
        );
    }
}

export default Ellipsis;
